import { Button } from 'antd'
import React from 'react'
import titul from '../fayl/titul.pdf'

const Titul = () => {
  return (
    <div>
      <Button className='button'>
        <a href={titul}
        >Titul</a>
      </Button>
    </div>
  )
}

export default Titul